"use client";
// Import the functions you need from the SDKs you need
import { type FirebaseOptions, initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyCECdFDKt0LkgfV4NV3-Z1UyXO1FmDm-Uo",
  authDomain: "ecomsaas-a2791.firebaseapp.com",
  projectId: "ecomsaas-a2791",
  storageBucket: "ecomsaas-a2791.firebasestorage.app",
  messagingSenderId: "798828669804",
  appId: "1:798828669804:web:49a63acbfe917a238d6149",
  measurementId: "G-YJ6WCMXLHV",
};

// Initialize Firebase
const firebaseapp = initializeApp(firebaseConfig);

export const messaging = () => getMessaging(firebaseapp);

export default firebaseapp;
